import type { MonthDuration, MonthPickerMonth } from '../types';
import { dateRangeFor, durationFor, monthFor } from './utils/buildParams';

type PrePackageHiddenInputsProps = {
    originAirport?: string;
    destination?: string;
    destinationCountry?: string;
    boundingBox?: string;
    departureDate?: Date | null;
    returnDate?: Date | null;
    flexibleDeparture?: number;
    travelMonths?: MonthPickerMonth[];
    duration?: MonthDuration;
    searchType?: string;
    numberOfAdults?: number;
    agesOfChildren?: number[];
};

export const PrepackageHiddenInputs = ({
    originAirport,
    destination,
    destinationCountry,
    boundingBox,
    departureDate,
    returnDate,
    flexibleDeparture,
    travelMonths,
    duration,
    searchType,
    numberOfAdults,
    agesOfChildren,
}: PrePackageHiddenInputsProps) => {
    const isFixed = searchType === 'fixed';
    const isFlexible = searchType === 'flexible';

    const allMonths = Array.from({ length: 12 }, (_, i) => {
        const date = new Date();
        date.setMonth(date.getMonth() + i);
        return `${date.getMonth() + 1}-${date.getFullYear()}`;
    });

    const selected = (travelMonths ?? []).map((m) => `${m.month}-${m.year}`);
    const isAllMonthsSelected = selected.length === 12 && allMonths.every((key) => selected.includes(key));

    const monthsToRender = isAllMonthsSelected ? [] : (travelMonths ?? []);

    return (
        <>
            {originAirport && <input type="hidden" name="fra" value={originAirport} />}
            {boundingBox && <input type="hidden" name="til" value={`${destination}|${destinationCountry}|${boundingBox}`} />}
            {isFixed && departureDate && flexibleDeparture && (
                <input type="hidden" name="avreise" value={dateRangeFor(departureDate, flexibleDeparture)} />
            )}
            {isFixed && returnDate && flexibleDeparture && (
                <input type="hidden" name="hjemreise" value={dateRangeFor(returnDate, flexibleDeparture)} />
            )}
            {isFlexible && duration && <input type="hidden" name="reiselengde" value={durationFor(duration)} />}
            {isFlexible &&
                monthsToRender.map((month) => {
                    const value = monthFor(month);
                    return <input key={`travel-month-${value}`} type="hidden" name="reiseperiode" value={value} />;
                })}
            {numberOfAdults && <input type="hidden" name="voksne" value={numberOfAdults} />}
            {agesOfChildren && agesOfChildren.length > 0 && <input type="hidden" name="alderBarn" value={agesOfChildren.join(',')} />}
        </>
    );
};
